import React from 'react';
import styled from 'styled-components';
import FooterColumn from './FooterColumn';
import Image from 'next/image';
import Button from '../../ui/Button';

const LogoImage = '/img/icons/logo.png';
const MailIcon = '/img/icons/mail.png';

export default function BlackBackground(){
  return <Container>
    <div className="maxwidth">
      <Logo>
        <Image src={LogoImage} alt="Таттехмедфарм" width={76} height={82} />
        <span>{/*Сайт создан при поддержке ГУП&quot;Таттехмедфарм&quot;*/}</span>
        <Button hrefOutside="https://farm.tatarstan.ru">Перейти на сайт предприятия</Button>

        <FooterInfo>
          Товары и их упаковка могут отличаться от представленных на изображениях, как по форме так и по дизайну, цветовой гамме, контрасту, размерам упаковки, обозначениям на товаре или упаковке.
        </FooterInfo>
      </Logo>

      <div></div>
      <div></div>

      <FooterColumn title="Меню" items={[
        {title: "Главная", link: "/"},
        {title: "Аптечное производство", link: "/pharmacies/type/proizv"},
        {title: "Алфавитный указатель", link: "/catalog/а/1"},
        {title: "О компании", link: "/text/about"},
        {title: "Статьи", link: "/articles/0"},
        {title: "Оставить отзыв", link: "/feedback"}
      ]} />
      <FooterColumn title="Контакты" items={[
        {title: "apteka-rt@ttmf.ru", link: "mailto:apteka-rt@ttmf.ru", icon: MailIcon},
      ]} />
    </div>
  </Container>
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  background-color: var(--color-bg-invert);
  color: var(--color-text-invert);

  padding: 30px 0 50px 0;

  & > div {
    justify-content: space-between;
    display: flex;
    align-items: flex-start;

    @media (max-width: 480px) {
      display: grid;
      grid-template-columns: 100%;
    }
  }

  @media (max-width: 1000px) {
    & > div > div:nth-child(2), & > div > div:nth-child(3), & > div > div:nth-child(4) {
      display: none;
    }
  }
`

const Logo = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 15px;

  & img {
    width: 80px;
    height: auto;
    margin-bottom: 10px;
  }

  & span {
    max-width: 210px;
    margin-bottom: 20px;
  }

`

const FooterInfo = styled.div`
  max-width: 400px;
  margin-top: 30px;
  color: #aaa;
`